export default __webpack_public_path__ + "static/media/Icons_9.12afca13.svg";